module.exports = __webpack_public_path__ + "img/home4.327a1757.jpg";